import { LitElement, html, css } from "lit";

/**
 * Image principe d'apparition au scroll dans le viewport avec lazyload
 */
export class LazyImage extends LitElement {

    static properties = {
        src: { type: String },
        alt: { type: String },
        imageSrc: { type: String },
        width: { type: String },
        height: { type: String },
        isInViewport: { type: Boolean },
        fadeIn: { type: Boolean },
    }

    constructor() {
        super();
        this.fadeIn = false;
        this.width = "100%";
        this.height = "auto";
        this.isInViewport = false;
    }

    static styles = css`
    picture, 
    img{
        display: block;
    }
    `;

    firstUpdated() {
        super.firstUpdated();
        var observer = new IntersectionObserver((e) => {
            if (e[0].isIntersecting && !this.isInViewport) {
                this.isInViewport = true;
                this.changeImgSrc()
            }
        }, {})
        observer.observe(this.image)
    }

    changeImgSrc() {
        this.image.style.opacity = 0;
        this.image.src = this.src;

        this.image.addEventListener('load', () => {
            if (this.fadeIn) {
                this.image.style.opacity = 0;
                this.image.animate([{ opacity: 0 }, { opacity: 1 }], { fill: "forwards", duration: 250 })
            }
            this.image.style.opacity = 1;
        })

    }

    get image() {
        return this.shadowRoot?.querySelector('img') ?? null
    }

    render() {
        return html`
        ${this.src ? html` <picture style="width: ${this.width}; height:${this.height}">
            <img alt="${this.alt}" width=${this.width} height=${this.height} />
        </picture>`: null}`
    }
}


customElements.define("lazy-image", LazyImage);